var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card-last',{attrs:{"title":"Awesome!"}},[_c('p',[_vm._v("Here’s a trophy to celebrate learning about testing! Keep going to collect more!")])])}
var staticRenderFns = []

export { render, staticRenderFns }